/**
 * 角色相关常量
 */

/** 角色名 -> key 映射（user store、useRoles 共用） */
export const ROLE_NAME_TO_KEY: Record<string, string> = {
  超级管理员: 'super_admin',
  AI运营: 'ai_operation',
  AI技术: 'ai_technical',
  客户超管: 'customer_admin',
  普通用户: 'customer_normal',
  客户员工: 'customer_normal',
  客户普通角色: 'customer_normal',
};

/** 角色卡片样式 */
export const ROLE_CARD_STYLES: Record<string, { bg: string; btn: string }> = {
  super_admin: { bg: 'bg-red-600', btn: 'default' },
  ai_operation: { bg: 'bg-blue-600', btn: 'primary' },
  ai_technical: { bg: 'bg-cyan-600', btn: 'primary' },
  customer_admin: { bg: 'bg-amber-600', btn: 'default' },
  customer_normal: { bg: 'bg-emerald-600', btn: 'default' },
};

/** 默认卡片样式 */
export const DEFAULT_STYLE = { bg: 'bg-slate-600', btn: 'default' };

/** 角色显示名映射（后端"普通用户"在 UI 展示为"客户员工"） */
export const ROLE_DISPLAY_NAME_MAP: Record<string, string> = {
  普通用户: '客户员工',
};

/** 获取角色显示名 */
export function getRoleDisplayName(name: string | undefined): string {
  if (!name) return '';
  return ROLE_DISPLAY_NAME_MAP[name] ?? name;
}
